/**************************************************
 * Nombre:       Formulario_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {AssignmentIndOutlined, BookmarkOutlined, Flag, FlagOutlined, GrassOutlined} from "@mui/icons-material";
import IngresoSelect from "../../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoImagenCrop from "../../../Modulo_formularios/Componentes/IngresoImagenCrop";
import {ESTADOSPRODUCTO} from "../../../Constantes";
import {useEffect, useState} from "react";
import {obtenerCol} from "../../../Servicios/BD/obtenerCol";
import IngresoSelectFalsoVerdadero from "../../../Modulo_formularios/Componentes/IngresoSelectFalsoVerdadero";

const Formulario_Producto = ({...props}) => {
    const [marcas, setMarcas] = useState([]);
    const [tipos, setTipos] = useState([]);
    const [reservas, setReservas] = useState([]);
    const [madureces, setMadureces] = useState([]);
    const [origenes, setOrigenes] = useState([]);


    useEffect(() => {

        obtenerCol('marcas').then(dox => {
            setMarcas(dox.data)
        })

        obtenerCol('categoriasTipo').then(dox => {
            setTipos(dox.data)
        })

        obtenerCol('categoriasReserva').then(dox => {
            setReservas(dox.data)
        })

        obtenerCol('categoriasOrigen').then(dox => {
            setOrigenes(dox.data)
        })

        obtenerCol('categoriasMadurez').then(dox => {
            setMadureces(dox.data)
        })

    }, []);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoImagenCrop dato={'img'} {...props} />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 12}}>Imagen con fondo transparente 300px por 300px maximo
                        300K</Typography>
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={Flag} nombre={'Estado'} dato={'estado'} {...props}
                                   requerido={'El estado es requerido'}
                                   opciones={ESTADOSPRODUCTO.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>

                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto nombre={'Nombre del producto'}
                                  dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={5} nombre={'Descripcion'} dato={'descripcion'} {...props}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AssignmentIndOutlined} nombre={'Nombre del mezcalero'}
                                  dato={'mezcalero'} {...props}
                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={BookmarkOutlined} nombre={'Marca'} dato={'marca'} {...props}
                                   opciones={marcas.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={GrassOutlined} nombre={'Tipo Agave'}
                                   dato={'tipo'} {...props} opciones={tipos.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={GrassOutlined} nombre={'Tipo de Reserva'}
                                   dato={'reserva'} {...props} opciones={reservas.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={GrassOutlined} nombre={'Origen Agave'}
                                   dato={'origen'} {...props} opciones={origenes.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoSelect Icono={GrassOutlined} nombre={'Madurez de Agave'}
                                   dato={'madurez'} {...props} opciones={madureces.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Extras</Typography>
                </Grid>

                <Grid container size={6}>
                    <IngresoSelectFalsoVerdadero Icono={FlagOutlined} nombre={'Mas Vendidos'}
                                                 dato={'masVendido'} {...props}
                    />
                </Grid>

            </Grid>

        </form>

    )

}
export default Formulario_Producto